import { faCircleQuestion } from '@skeepers/skeepers-icons/solid/faCircleQuestion';
import { SkpLink } from '@skeepers/skeepers-ui-react';
import { withTranslation } from 'react-i18next';

import { SUPPORT_URL } from '@app/config';
import { getLanguageCode } from '@app/i18n';

import style from './style.module.css';

const zendeskLanguageConfig = {
  'fr-FR': 'fr',
  fr: 'fr',
  'en-US': 'en-us',
  en: 'en-us',
}

const SupportWidget = ({ connectedUser = {}, brief = {}, t = () => {} }) => {
  const languageCode = getLanguageCode();

  if (!connectedUser) return null;

  const dynamicFields = {
    EMAIL: connectedUser.email,
    URL: window.location.href,
    LANGUAGE: zendeskLanguageConfig[languageCode] || zendeskLanguageConfig.en,
    SUBJECT: brief?.company?.name,
    DESCRIPTION: t('\n\n\nIssue location: {{url}}', { url: window.location.href }),
  };

  const link = Object.keys(dynamicFields).reduce((link, part) => link.replace(`[${part}]`, encodeURIComponent(dynamicFields[part])), SUPPORT_URL);

  return <SkpLink icon={faCircleQuestion} type="standalone" standalone-variant="secondary" text={t('Technical assistance')} size="medium" link={link} className={style.link} />
}

export default withTranslation()(SupportWidget);
